export default __webpack_public_path__ + "static/media/piernacht.4fcf0d7a.jpg";